import { Moment } from 'moment';
import { DataRobot, UnderwriteModel } from '../api/api-types';
export type { DataRobot } from '../api/api-types';

export enum PreReqs {
    Ibv = 1,
    ClarityFraud = 2,
    ClarityClearBankBehavior = 3,
    Ekata = 4,
    DataXIDV = 5,
    DataXBAV = 6,
    DataXCreditReport = 7,
    DataXChex = 8,
    DataXScoreAction = 9,
    Neustar = 12,
    ClarityRecentHistory = 13,
    ValidiFIvFraud = 14,
    ValidiFIvAccountPlus = 15,
    ValidiFIvCredit = 16,
    ValidiFIvIndex = 17,
    Sentilink = 18,
    SEONFraud = 21,
    FT_OFAC_Check = 22,
    FT_IDLogic = 23,
    FT_Application_Check = 24,
    FT_Insolvency_Logic_v2 = 25,
    FT_MLA_Check = 26,
    FT_TU_Traditional_Credit_Attributes = 27,
    FT_TU_Alternative_Credit_Attributes_v2 = 28,
    ScoreMyCash_CashVerifi = 29,
    Congruit_AchExchange = 30,
    Congruit_Nopay3Exchange = 31,
    Congruit_Resolution = 32,
    Congruit_ResolutionVerify = 33
}
export const preReqListArray = Object.keys(PreReqs)
    .filter((x) => parseInt(x))
    .map((x) => Number(x));

export type ModelTypes = Pick<UnderwriteModel, 'modelType'>['modelType'];

export type EqualitySymbol = 'GT' | 'GTE' | 'E' | 'LT' | 'LTE' | 'LK' | 'NE';

export type DataType = 'System.Decimal' | 'System.DateTime' | 'System.String'; //TODO: This isn't complete. Complete this

export type DecisionModel = {
    modelType: 'Decision';
    decision: Decision;
};

export type PriceModel = {
    modelType: 'Price';
    price: Price;
};

export type DenyModel = {
    modelType: 'Deny';
    denyRules: DenyRule[];
};

export type RiskModel = {
    modelType: 'Risk';
    risk: Risk;
};

export type ModelT<K> = Model & K;

export type Models = ModelT<DenyModel> | ModelT<DecisionModel> | ModelT<RiskModel> | ModelT<PriceModel>;

export interface Model {
    name: string | null;
    modelId: number;
    activeStart: Moment;
    activeEnd: Moment;
    groupId: number | null;
    groupWeight: number | null;
    modelType: ModelTypes;
    lowAmount: number;
    highAmount: number;
    preReqs: number[] | null;
    errorCount?: number;
}

export type ModelError = {
    modelID: number;
    createdOn: Moment;
    error: string;
};

export interface Decision extends NonNullable<DataRobot> {
    acceptLimit: number;
    acceptSymbol: EqualitySymbol;
    denyLimit: number;
    denySymbol: EqualitySymbol;
}

export interface DenyRule {
    type: DataType;
    key: string;
    symbol: EqualitySymbol;
    value: string;
}

export interface Price extends NonNullable<DataRobot> {
    multiplier: number;
    minAmount: number;
    maxAmount: number;
    slope:number;
    intercept:number;
}

export interface RiskBasedCredit extends NonNullable<DataRobot> {
    increment: number;
    scoreModifier: number;
    scoreMultiplier: number;
    range: {
        low: number;
        high: number;
    };
}

export interface Risk extends RiskBasedCredit {

}

export interface ErrorFilter {
    startDate: Moment;
    endDate: Moment;
    modelID: number;
}